import React, { PropsWithChildren } from 'react'

import { ThemeProps } from '@hhgtech/hhg-components'
import { SectionContainerStyled } from 'components/atoms/container/index.styled'
import styled from 'styled-components'
import { deviceLayout } from 'styles/breakpoint'

const HeaderDescriptionStyled = styled(SectionContainerStyled)`
  width: 100%;
  padding: 16px 24px;
  padding-bottom: 48px;
  ${deviceLayout.pcLayout`
          background-color: ${(props: ThemeProps) =>
            props.theme.mbColors.lightPink};
       border-radius: 0% 0% 50% 50% / 0% 0% 20% 20%;
    `}
`

interface IHeaderDescription {
  as?: string
}

const HeaderDescription = ({
  children,
}: PropsWithChildren<IHeaderDescription>) => {
  return (
    <HeaderDescriptionStyled as="header" className="header-description">
      {children}
    </HeaderDescriptionStyled>
  )
}

export default HeaderDescription
